import { useRefresh, useSelf } from 'api/queries';

export const UserHelper = () => {
  useSelf();
  useRefresh();
  return null;
};
